import React from 'react'
import QRCode from 'qrcode.react'
import { inject } from 'mobx-react'
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Divider from 'material-ui/Divider'
import List, {
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  ListSubheader,
} from 'material-ui/List'
import Avatar from 'material-ui/Avatar'
import T from 'i18n-react'
import route from '../stores/fetchconfig.json'

const shortUrl = require('node-url-shortener')

/* deprecated
const googleURLShortenerAPIKey = "AIzaSyAEQSfnse_TKCnwe65ZtY6DvRWfDcEPDn4"
const GoogleURL = require( 'google-url' ), googleUrl = new GoogleURL({key:googleURLShortenerAPIKey})
*/

@inject('store','ui')
class PDFCollectionTeacher extends React.Component {
 constructor (props) {
   super(props)
   this.state = {kompetenzstufen:[],sharelink:this.props.store.cart.sharelink}
 }

 addPrintEventsToWindow () {
   window.onafterprint = () => {
    this.props.history.replace(route.endpoint+'/')
   }
 }

 printIt () {
   if (window.location.pathname.indexOf('teacher') > -1) {
     setTimeout(window.print,80)
   }
 }

 componentWillMount () {
   this.addPrintEventsToWindow()

   const { store } = this.props
   const ids = store.getParameterByName('ids')
   let kompetenzstufen = []

   store.getItems(ids,response => {
    const items = response.items

    store.forEach(
     items,
     (item,callback) => {
      item.kompetenzstufen.map(ks => kompetenzstufen.push(ks))
      callback()
     },
     (results) => {
      kompetenzstufen = this.removeDuplicates(kompetenzstufen)
      const cycle1 = this.sortByCycle(kompetenzstufen,1)
      const cycle2 = this.sortByCycle(kompetenzstufen,2)
      const cycle3 = this.sortByCycle(kompetenzstufen,3)
      const orientierungsPunkt12 = this.sortByOrientierungsPunkt12(kompetenzstufen)
      const orientierungsPunkt23 = this.sortByOrientierungsPunkt23(kompetenzstufen)

      kompetenzstufen = [...cycle1,...orientierungsPunkt12,...cycle2,...orientierungsPunkt23,...cycle3]
      /*shortUrl.short(store.cart.sharelink, (err, shortUrl) => {
       this.setState({kompetenzstufen:kompetenzstufen,sharelink:shortUrl},() => {
        if (this.props.isReady) this.props.isReady()
        else this.printIt()
       })
      })*/
       this.setState({kompetenzstufen:kompetenzstufen,sharelink:store.cart.sharelink},() => {
        if (this.props.isReady) this.props.isReady()
        else this.printIt()
       })
     }
    )

   })
 }

 removeDuplicates (arr) {
   return arr.filter((obj, pos, arr) => {
     return arr.map(mapObj => mapObj['id']).indexOf(obj['id']) === pos
   })
 }

 sortByCycle (arr,cycle) {
   return arr.filter(ks => {
     if (cycle === 1 && ks.zyklus1 && !ks.zyklus2 && !ks.zyklus3) return ks
     if (cycle === 2 && !ks.zyklus1 && ks.zyklus2 && !ks.zyklus3) return ks
     if (cycle === 3 && !ks.zyklus1 && !ks.zyklus2 && ks.zyklus3) return ks
   })
 }

 sortByOrientierungsPunkt12 (arr) {
   return arr.filter(ks => {
     if (ks.zyklus1 && ks.zyklus2) return ks
   })
 }

 sortByOrientierungsPunkt23 (arr) {
   return arr.filter(ks => {
     if (ks.zyklus2 && ks.zyklus3) return ks
   })
 }

 render () {
  const { classes,ui } = this.props
  const { kompetenzstufen } = this.state

  const { sharelink } = this.state

  return (
   <div className={classes.container}>

    <div className={classes.collectionLinkContainer}>
     <div className={classes.qrCode}>
      <QRCode value={sharelink} size={64} />
     </div>
     <Typography type="caption"> {T.translate('pdf.collectionLink')} </Typography>
     <a href={sharelink} className={classes.collectionLink}> {sharelink} </a>
    </div>

    <div className={classes.divider} />

    <List>
     {kompetenzstufen.map( (ks,index) => {
       return <ListItem key={'ks-'+index} dense button divider={true}>
         <Avatar className={ui.getZyklusColor(ks)}> {ui.getZyklusAsString(ks)} </Avatar>
         <ListItemText primary={ks.kompetenzstufe} secondary={ks.code}/>
        </ListItem>
      })
     }
    </List>
   </div>
  )
 }
}


const styles = theme => ({
  container: {
   position:'relative',
   padding:10
  },
  collectionLinkContainer:{
   'text-align':'right'
  },
  collectionLink:{
   'float':'right'
  },
  divider:{
   clear:'both',
   'border-bottom':'1px solid #ddd',
   height:1,
   'padding-bottom':10
  },
  qrCode:{
    float:'left'
  }
})


export default withStyles(styles, { withTheme: true }) (PDFCollectionTeacher)



// WEBPACK FOOTER //
// ./src/components/PDFCollectionTeacher.js